import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Search Performed ", -1)
const _hoisted_7 = {
  key: 0,
  class: "hstack gap-2"
}
const _hoisted_8 = { class: "inputWrapper" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Basis for Search</label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)
const _hoisted_10 = { class: "inputWrapper" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Requested Permission</label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)
const _hoisted_12 = { class: "inputWrapper" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Granted Permission</label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)
const _hoisted_14 = { class: "inputWrapper" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Contraband Found</label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = {
  key: 1,
  class: "container-fluid mt-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, "Property Seized", -1)
const _hoisted_19 = {
  class: "row border bg-light d-flex align-items-center",
  style: {"height":"56px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 h-100 d-flex align-items-center" }, "Property Description", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 h-100 d-flex align-items-center border-start" }, "Basis for Seizure", -1)
const _hoisted_22 = { class: "col-2 h-100 d-flex align-items-center border-start" }
const _hoisted_23 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectField = _resolveComponent("SelectField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Search of " + _toDisplayString(_ctx.searchDetailsData.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault",
          checked: _ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string) > -1,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSearchPerformedChange($event, _ctx.citizen, _ctx.searchDetailsData.value as string)))
        }, null, 40, _hoisted_5),
        _hoisted_6
      ]),
      (_ctx.citizen != undefined && _ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string) != -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_SelectField, {
                modelValue: _ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].basis_for_search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].basis_for_search) = $event)),
                "select-items": _ctx.contactsStore.getSearchBasis,
                "is-horizontal": false,
                "is-required": true,
                ref: (el) => { _ctx.addValidatableComponent(el) }
              }, null, 8, ["modelValue", "select-items"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_SelectField, {
                modelValue: _ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].requested_permission,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].requested_permission) = $event)),
                "select-items": _ctx.contactsStore.getYesNo,
                "is-horizontal": false,
                "is-required": true,
                ref: (el) => { _ctx.addValidatableComponent(el) }
              }, null, 8, ["modelValue", "select-items"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_SelectField, {
                modelValue: _ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].granted_permission,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].granted_permission) = $event)),
                "select-items": _ctx.contactsStore.getYesNoUnknown,
                "is-horizontal": false,
                "is-required": true,
                ref: (el) => { _ctx.addValidatableComponent(el) }
              }, null, 8, ["modelValue", "select-items"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].contraband_found) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.citizen.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].contraband_found]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.citizen != undefined && _ctx.citizen.search_details != undefined && _ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string) != -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handlePropertySeizedAddClick(_ctx.citizen!.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)])), ["prevent"]))
                }, "Add")
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citizen.search_details[_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].seized_property, (seizedProperty, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row border d-flex align-items-center",
                key: _ctx.keyColumn
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-5 p-2 text-center"])
                }, [
                  _createVNode(_component_SelectField, {
                    modelValue: seizedProperty.property_description,
                    "onUpdate:modelValue": ($event: any) => ((seizedProperty.property_description) = $event),
                    "select-items": _ctx.contactsStore.getPropertyType,
                    "is-horizontal": false,
                    "is-required": true,
                    ref_for: true,
                    ref: (el) => { _ctx.addValidatableComponent(el) }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-5 p-2 text-center"])
                }, [
                  _createVNode(_component_SelectField, {
                    modelValue: seizedProperty.seized_basis,
                    "onUpdate:modelValue": ($event: any) => ((seizedProperty.seized_basis) = $event),
                    "select-items": _ctx.contactsStore.getPropertySeizureBasis,
                    "is-horizontal": false,
                    "is-required": true,
                    ref_for: true,
                    ref: (el) => { _ctx.addValidatableComponent(el) }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-2 p-2 mt-1 text-end"])
                }, [
                  _createElementVNode("button", {
                    class: "btn-close me-3",
                    "aria-label": "Remove",
                    onClick: _withModifiers(($event: any) => (_ctx.handleRemove(_ctx.citizen!.search_details![_ctx.getSearchDetailsIndex(_ctx.citizen, _ctx.searchDetailsData.value as string)].seized_property, index)), ["prevent"])
                  }, null, 8, _hoisted_23)
                ], 2)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}